import { defineStore } from 'pinia'

export const AllPeriods = defineStore('sch_prds', {
    state: () => {
        return { sch_prds: null }
    },
    actions: {
        get() {
            return this.sch_prds
        },
        set(data) {
            this.sch_prds = data
        }
    },
})